import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();

export default class ReportAPI {

    URI_V1 = "/v1/reports"

    getReportSummary = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        var query = `startDate=${filter.startDate}&endDate=${filter.endDate}`;
        if (filter.commandStatus) {
            query += `&commandStatus=${filter.commandStatus}`
        }

        if (filter.employeeId) {
            query += `&employeeId=${filter.employeeId}`
        }

        if (filter.paymentType) {
            query += `&paymentType=${filter.paymentType}`
        }

        return await apiService.get(`${this.URI_V1}/company/${companyAPI.getCompanyManagment().id}/summary?${query}`);
    };

    getReportFullSummary = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        var query = `startDate=${filter.startDate}&endDate=${filter.endDate}`;
        if (filter.commandStatus) {
            query += `&commandStatus=${filter.commandStatus}`
        }

        if (filter.employeeId) {
            query += `&employeeId=${filter.employeeId}`
        }

        if (filter.paymentType) {
            query += `&paymentType=${filter.paymentType}`
        }

        return await apiService.get(`${this.URI_V1}/company/${companyAPI.getCompanyManagment().id}/full-summary?${query}`);
    };

    getReportService = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        var query = `startDate=${filter.startDate}&endDate=${filter.endDate}`;
        if (filter.commandStatus) {
            query += `&commandStatus=${filter.commandStatus}`
        }

        if (filter.employeeId) {
            query += `&employeeId=${filter.employeeId}`
        }

        if (filter.paymentType) {
            query += `&paymentType=${filter.paymentType}`
        }

        return await apiService.get(`${this.URI_V1}/company/${companyAPI.getCompanyManagment().id}/service?${query}`);
    };

    getReportCustomer = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        var query = `startDate=${filter.startDate}&endDate=${filter.endDate}`;

        return await apiService.get(`${this.URI_V1}/company/${companyAPI.getCompanyManagment().id}/customers?${query}`);
    };

    getReportTotalGross = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        const companyId = companyAPI.getCompanyManagment().id;
    
        const params = new URLSearchParams();
    
        params.append("companyId", String(companyId));
        params.append("startDate", filter.startDate);
        params.append("endDate", filter.endDate);
        params.append("limit", String(filter.limit ?? 5));
    
        // cursores (só envia se existirem)
        if (filter.cursorEventDate) {
            params.append("cursorEventDate", filter.cursorEventDate);
        }
    
        if (filter.cursorCreatedAt) {
            params.append("cursorCreatedAt", filter.cursorCreatedAt);
        }
    
        if (filter.cursorSource) {
            params.append("cursorSource", filter.cursorSource);
        }
    
        if (filter.cursorSourceId !== null && filter.cursorSourceId !== undefined) {
            params.append("cursorSourceId", String(filter.cursorSourceId));
        }
    
        return await apiService.get(
            `${this.URI_V1}/gross-detail?${params.toString()}`
        );
    };
    
    getReportTotalGrossSummary = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        const companyId = companyAPI.getCompanyManagment().id;
    
        const params = new URLSearchParams();
    
        params.append("companyId", String(companyId));
        params.append("startDate", filter.startDate);
        params.append("endDate", filter.endDate);
 
    
        return await apiService.get(
            `${this.URI_V1}/gross-detail-summary?${params.toString()}`
        );
    };

    getReportTotalNetSummary = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        const companyId = companyAPI.getCompanyManagment().id;
    
        const params = new URLSearchParams();
    
        params.append("companyId", String(companyId));
        params.append("startDate", filter.startDate);
        params.append("endDate", filter.endDate);
 
    
        return await apiService.get(
            `${this.URI_V1}/net-detail-summary?${params.toString()}`
        );
    };

    getReportTotalVisits = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        const companyId = companyAPI.getCompanyManagment().id;
    
        const params = new URLSearchParams();
    
        params.append("companyId", String(companyId));
 
    
        return await apiService.get(
            `${this.URI_V1}/visit-detail?${params.toString()}`
        );
    };


  
}
